import { render, staticRenderFns } from "./ExpensesTableUser.vue?vue&type=template&id=bf2a4ba4&scoped=true"
import script from "./ExpensesTableUser.vue?vue&type=script&lang=js"
export * from "./ExpensesTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2a4ba4",
  null
  
)

export default component.exports